'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const NonReentrantCommand=require('../../../../dist-es6/client/angularCommon/nonReentrantCommand');let

CommandStatusDirective=function(_BaseControllerBacked){_inherits(CommandStatusDirective,_BaseControllerBacked);function CommandStatusDirective(){_classCallCheck(this,CommandStatusDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(CommandStatusDirective,[{key:'objectBindings',get:function()
{
return['command'];
}},{key:'textBindings',get:function()

{
return['inProgressText','completionText'];
}},{key:'templateUrl',get:function()

{
return'/templates/directives/commandStatusDirective/commandStatusTemplate';
}},{key:'controller',get:function()

{
return CommandStatusDirectiveController;
}}]);return CommandStatusDirective}(BaseControllerBackedDirective);let


CommandStatusDirectiveController=function(){_createClass(CommandStatusDirectiveController,null,[{key:'$inject',get:function()
{
return['$scope','$timeout','$element'];
}}]);

function CommandStatusDirectiveController($scope,$timeout,$element){var _this2=this;_classCallCheck(this,CommandStatusDirectiveController);
if(!_.exists(this.command)||!(this.command instanceof NonReentrantCommand)){
throw new Error('CommandStatusDirective must get NonReentrantCommand as controller.command');
}

this.inProgressText=!_.exists(this.inProgressText)||this.inProgressText===''?'Saving...':this.inProgressText;
this.completionText=!_.exists(this.completionText)||this.completionText===''?'Saved':this.completionText;

this._showCompletionText=!1;
this._$timeout=$timeout;

$scope.$watch('controller.command',function(){
if(_.exists(_this2._observer)){
_this2._observer.dispose();
}

_this2._observer=_this2.command.onInProgressChanged.subscribe(_this2._onInProgressChangedHandler.bind(_this2));
});

$scope.$on('$destroy',function(){
_this2._observer.dispose();
});
}CommandStatusDirectiveController.prototype.

_onInProgressChangedHandler=function _onInProgressChangedHandler(isInProgress){
if(isInProgress){
this._hideCompletionText();
return;
}

this._showCompletionTextForSeconds(2);
};CommandStatusDirectiveController.prototype.

_hideCompletionText=function _hideCompletionText(){var _this3=this;
this._$timeout(function(){
_this3._showCompletionText=!1;
if(_this3._outstandingTextUpdate){
_this3._$timeout.cancel(_this3._outstandingTextUpdate);
_this3._outstandingTextUpdate=null;
}
});
};CommandStatusDirectiveController.prototype.

_showCompletionTextForSeconds=function _showCompletionTextForSeconds(timeInSeconds){var _this4=this;
this._$timeout(function(){
_this4._showCompletionText=!0;
_this4._outstandingTextUpdate=_this4._$timeout(function(){
_this4._showCompletionText=!1;
_this4._outstandingTextUpdate=null;
},timeInSeconds*1000);
});
};_createClass(CommandStatusDirectiveController,[{key:'currentStatusText',get:function()

{

return this.showInProgressText?this.inProgressText:this.completionText;
}},{key:'showInProgressText',get:function()

{
return this.command.inProgress||this.command.completed&&this.completionText.length===0;
}},{key:'showCompletionText',get:function()

{
return this._showCompletionText;
}}]);return CommandStatusDirectiveController}();



module.exports=CommandStatusDirective;
//# sourceMappingURL=commandStatusDirective.js.map
